/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';
import restClient from '../../app/helpers/restClient';
import { getAccessTokenSafely } from '../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

export const fetchActiveSocialConnections = async (client_id) => {
    const token = await getAccessTokenSafely();
    const wcEnv = { rootUri: '/' };
    const resourcePage = `profile/auth0/getActiveSocialConnections/${client_id}`;
    let data = {
        status: false,
        activeconnections: [
            {
                name: 'google',
                strategy: 'google-oauth2',
            },
            {
                name: 'apple',
                strategy: 'apple',
            },
        ],
    };

    try {
        const response = await restClient.getFacade(wcEnv, resourcePage, token, null, null, false);
        const activeconnections = response?.data;
        data = {
            activeconnections,
            status: true,
        };
        return data;
    } catch (err) {
        data = {
            ...data,
            code: err.status,
        };
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: err,
            message: 'fetchActiveSocialConnections: Error while fetching active social connections for the brand.',
        });
        return data;
    }
};

export default {};
